module.exports = __webpack_public_path__ + "ColabThi.8469e49e471423a1693b.woff";


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/assets/font/colaborate/ColabThi.woff
// module id = ../../../../../src/assets/font/colaborate/ColabThi.woff
// module chunks = 2